<template>
  <div style="display: flex;flex-direction: column;">
    <div>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="客户名称">
            <Input v-model="formItem.Customer" placeholder="请输入客户名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
        </div>
      </FormItem>
    </Form>
    </div>

     <Table  ref="selection" :columns="columns12" :data="CustomerList" max-height="600" @on-select="SelecttionHandleClick">
    </Table>
    <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
    <Spin size="large" fix v-if="SpinShow"></Spin>
  </div>
</template>

<script>
import { CustomerListApi } from '../../../../api/Miscellaneous.js'
export default {
  name: 'NonStandardCustomer',
  data () {
    return {
      formItem: {
        Customer: ''
      },
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'Openid',
          key: 'openid'
        },
        {
          title: '客户名称',
          key: 'Customer_Name'
        }
      ],
      CustomerList: [],
      SalespersonID: '',
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      SpinShow: false
    }
  },
  mounted: function () {
    if (this.$store.state.userInfo.roleName === '销售员') { this.SalespersonID = this.$store.state.userInfo.userID }
    this.GetCustomerList()
  },
  methods: {
    GetCustomerList () {
      CustomerListApi(this.SalespersonID, this.formItem.Customer, this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.CustomerList = res.Data.Table1
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    SelecttionHandleClick (selection, row) {
      this.$emit('SelecttionHandleClick', row)
      this.GetCustomerList()
    },
    QueryHandleClick () {
      if (this.formItem.Customer !== '') {
        this.GetCustomerList()
      } else {
        this.$Message.error('请输入客户名称')
      }
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetCustomerList()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetCustomerList()
      }
    }
  }
}
</script>
